import { BsFillMoonFill, BsFillSunFill } from "react-icons/bs";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link } from "react-router-dom";
import { useGlobalContext } from "../../context";
import "./navbar.css";

const Navbar = () => {
  const toggleHamNav = () => {
    const hamNav = document.getElementById("hamNav");
    const hamBurgerIcon = document.getElementById("hamBurgerIcon");
    if (hamNav) {
      if (hamNav.style.opacity === "1") {
        hamNav.style.opacity = "0";
        hamNav.style.visibility = "hidden";
        hamBurgerIcon.style.transform = "rotate(0deg)";
      } else {
        hamNav.style.opacity = "1";
        hamNav.style.visibility = "visible";
        hamBurgerIcon.style.transform = "rotate(90deg)";
      }
    }
  };

  const { toggleTheme, theme, goToTop, activeLink } = useGlobalContext();

  return (
    <div>
      <nav className="navBarContainer fadeDown">
        <div className="logoContainer">
          <Link to="/" className="logoAnchor" onClick={() => goToTop("home")}>
            <h1 className="logoHead">SonuBardai</h1>
          </Link>
        </div>
        <ul className="linksContainer">
          <li className="linkItem fadeDown" style={{ animationDelay: "600ms" }}>
            <Link to="/" className={activeLink === "home" ? "linkAnchor activeLink" : "linkAnchor"} onClick={() => goToTop("home")}>
              Home
            </Link>
          </li>

          {/* <li className="linkItem fadeDown" style={{ animationDelay: "700ms" }}>
            <a href={process.env.PUBLIC_URL + "/Sonu-Bardai-Resume.pdf"} className="linkAnchor" target="_blank" rel="noreferrer">
              Resume
            </a>
          </li> */}

          <li className="linkItem fadeDown" style={{ animationDelay: "800ms" }}>
            <Link to="/projects" className={activeLink === "projects" ? "linkAnchor activeLink" : "linkAnchor"} onClick={() => goToTop("projects")}>
              Projects
            </Link>
          </li>

          <li className="linkItem fadeDown" style={{ animationDelay: "900ms" }}>
            <Link to="/blogs" className={activeLink === "blogs" ? "linkAnchor activeLink" : "linkAnchor"} onClick={() => goToTop("blogs")}>
              Blogs
            </Link>
          </li>

          <li className="linkItem fadeDown" style={{ animationDelay: "1000ms" }}>
            <Link to="/art" className={activeLink === "art" ? "linkAnchor activeLink" : "linkAnchor"} onClick={() => goToTop("art")}>
              ArtGallery
            </Link>
          </li>

          {/* <li
            className="linkItem fadeDown"
            style={{ animationDelay: "1100ms" }}
          >
            <Link
              to="/about"
              className={
                activeLink === "about" ? "linkAnchor activeLink" : "linkAnchor"
              }
              onClick={() => goToTop("about")}
            >
              About
            </Link>
          </li> */}

          <li className="linkItem fadeDown" style={{ animationDelay: "1200ms" }}>
            <Link to="/contact" className={activeLink === "contact" ? "linkAnchor activeLink" : "linkAnchor"} onClick={() => goToTop("contact")}>
              Contact
            </Link>
          </li>
          <div>
            <button className="themeBtn fadeDown" style={{ animationDelay: "1300ms" }}>
              {theme === "dark" ? <BsFillSunFill className="themeIcon" onClick={toggleTheme} /> : <BsFillMoonFill className="themeIcon" onClick={toggleTheme} />}
            </button>
          </div>
        </ul>
      </nav>

      <nav className="mobileNavBar" id="mobileNavBar">
        <div className="mobileLogoContainer">
          <Link
            to="/"
            className="logoAnchor"
            onClick={() => {
              goToTop("home");
            }}
          >
            <h1 className="logoHead">SonuBardai</h1>
          </Link>
        </div>
        <ul className="mobilelinksContainer linksContainer" id="hamNav" style={{ opacity: "0", visibility: "hidden" }}>
          <li className="linkItem">
            <Link
              to="/"
              className={activeLink === "home" ? "linkAnchor activeLink" : "linkAnchor"}
              onClick={() => {
                goToTop("home");
                toggleHamNav();
              }}
            >
              Home
            </Link>
          </li>

          {/* <li className="linkItem">
            <a href={process.env.PUBLIC_URL + "/Sonu-Bardai-Resume.pdf"} className="linkAnchor" target="_blank" rel="noreferrer">
              Resume
            </a>
          </li> */}

          <li className="linkItem">
            <Link
              to="/projects"
              className={activeLink === "projects" ? "linkAnchor activeLink" : "linkAnchor"}
              onClick={() => {
                goToTop("projects");
                toggleHamNav();
              }}
            >
              Projects
            </Link>
          </li>

          <li className="linkItem">
            <Link
              to="/blogs"
              className={activeLink === "projects" ? "linkAnchor activeLink" : "linkAnchor"}
              onClick={() => {
                goToTop("blogs");
                toggleHamNav();
              }}
            >
              Blogs
            </Link>
          </li>

          <li className="linkItem">
            <Link
              to="/art"
              className={activeLink === "art" ? "linkAnchor activeLink" : "linkAnchor"}
              onClick={() => {
                goToTop("art");
                toggleHamNav();
              }}
            >
              ArtGallery
            </Link>
          </li>

          {/* <li className="linkItem">
            <Link
              to="/about"
              className={
                activeLink === "about" ? "linkAnchor activeLink" : "linkAnchor"
              }
              onClick={() => {
                goToTop("about");
                toggleHamNav();
              }}
            >
              About
            </Link>
          </li> */}

          <li className="linkItem">
            <Link
              to="/contact"
              className={activeLink === "contact" ? "linkAnchor activeLink" : "linkAnchor"}
              onClick={() => {
                goToTop("contact");
                toggleHamNav();
              }}
            >
              Contact
            </Link>
          </li>
          <div>
            <button className="themeBtn">
              {theme === "dark" ? <BsFillSunFill className="themeIcon" onClick={toggleTheme} /> : <BsFillMoonFill className="themeIcon" onClick={toggleTheme} />}
            </button>
          </div>
        </ul>

        <div>
          <GiHamburgerMenu className="hamBurgerIcon" id="hamBurgerIcon" onClick={toggleHamNav} />
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
